<div class="container">
         <div class="search-section">
           <span class="p-input-icon-left">
             <i class="pi pi-search"></i>
  <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Search" class=" p-inputtext-sm" />
                             <!-- <p-button icon="pi pi-search" (onClick)="searchProjectBom()" [style]="{'margin': '5px', 'height': '35px', 'line-height': '50px'}" [raised]="true" [size]="'small'" severity="info"></p-button> -->
            </span>
          </div>
          <!-- <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true" severity="info" class="refresh-button"></p-button> -->
    </div>
            <p-table #dt1 [value]="result.projectBOM" [scrollable]="true" scrollHeight="350px"
            styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm"
            [paginator]="true" [rows]="5" [selectionPageOnly]="true" (onPage)="loadBom($event)"
            [(selection)]="selectedprojectbom" [globalFilterFields]="['projectBoMCode','projectBoMName']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[5, 10, 20]" (onRowSelect)="SelectOption($event)">
            <ng-template pTemplate="header">
            <tr>
                <th style="width: 4rem">
                    <!-- <p-tableHeaderCheckbox></p-tableHeaderCheckbox> -->
                </th>
                <th>Project Code</th>
                <th>Project Name</th>
                <th>Categories</th>
                <th>Created Date</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-projectbom>
          <tr (click)="SelectOption(projectbom)">
              <td>
                  <p-tableCheckbox [value]="projectbom"></p-tableCheckbox>
              </td>
              <td>{{ projectbom?.projectBoMCode }}</td>
              <td>{{ projectbom.projectBoMName }}</td>
              <td>
                  <div *ngFor="let budget of projectbom.projectBudgets">
                      {{ budget.categoryName }} - {{ budget.estimatedCost | number: '1.2-2' }}
                      <span *ngIf="budget !== projectbom.projectBudgets[projectbom.projectBudgets.length - 1]"> | </span>
                  </div>
                </td>
              <td>{{ projectbom?.createdDate | date: 'dd/MM/yyyy' }}</td>
          </tr>
      </ng-template>
    </p-table>
